import PropTypes from 'prop-types';
import RaaChannelKey from '../../classes/RaaChannelKey';

const listAlertPropType = PropTypes.shape({
  id: PropTypes.number,
  triggeredAlertEventId: PropTypes.number || null,
  channelId: PropTypes.number,
  triggeredTimestamp: PropTypes.number,
  description: PropTypes.string,
  temperatureScale: PropTypes.string,
  timezone: PropTypes.string,
  isSuspended: PropTypes.bool,
  isDeviceSuspended: PropTypes.bool,
  dateCreated: PropTypes.number, // timestamp
  dateEnded: PropTypes.number || null,
  startThreshold: PropTypes.number,
  startOperatorTypeId: PropTypes.number,
  conditionType: PropTypes.string,
  acknowledgementTimestamp: PropTypes.number || null,
  channelGroupName: PropTypes.string,
  deviceName: PropTypes.string,
  lastSampleTimestamp: PropTypes.number,
  lastSampleValue: PropTypes.string,
  isFavorite: PropTypes.bool,
  actionCount: PropTypes.number,
  channelKey: PropTypes.instanceOf(RaaChannelKey),
  isPushing: PropTypes.bool,
  customUnit: PropTypes.string || null,
  tagIds: PropTypes.arrayOf(PropTypes.number),
});

export default {
  listAlertPropType,
};
